import { lazy } from 'react';

const NotFound = lazy(() => import('@comp/Error404Page'));

export const error404Route = {
  path: '*',
  element: <NotFound />
};
